(function () {
    'use strict';

    angular.module('app.reviews')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reviews',
                config: {
                    url: '/reviews',
                    title: 'Yorumler',
                    abstract: true,
                    templateUrl: 'app/reviews/reviews.html'
                }
            },
            {
                state: 'reviews.list',
                config: {
                    templateUrl: 'app/reviews/reviews.list.html',
                    controller: 'ReviewsListController',
                    controllerAs: 'vm',
                    url: '/list',
                    title: 'Yorum Listesi',
                    settings: {
                        nav: 10,
                        name: 'reviews.list',
                        topName: 'products',
                        content: 'Yorum Listesi',
                        resource: 'menu.reviews.list'
                    }
                }
            },
            {
                state: 'reviews.add',
                config: {
                    templateUrl: 'app/reviews/reviews.add.html',
                    controller: 'ReviewsAddController',
                    controllerAs: 'vm',
                    url: '/add',
                    title: 'Yorum Ekle',
                    settings: {
                        name: 'reviews.add',
                        topName: 'reviews.list',
                        content: 'Yorum Ekle',
                        resource: 'menu.reviews.add'
                    }
                }
            },
            {
                state: 'reviews.edit',
                config: {
                    templateUrl: 'app/reviews/reviews.edit.html',
                    controller: 'ReviewsEditController',
                    controllerAs: 'vm',
                    url: '/edit/:Id',
                    title: 'Yorum Düzenle',
                    settings: {
                        name: 'reviews.edit',
                        topName: 'reviews.list',
                        content: 'Yorum Düzenle',
                        resource: 'menu.reviews.edit'
                    }
                }
            },
            {
                state: 'reviews.detail',
                config: {
                    templateUrl: 'app/reviews/reviews.detail.html',
                    controller: 'ReviewsDetailController',
                    controllerAs: 'vm',
                    url: '/detail/:Id',
                    title: 'Yorum Detay',
                    settings: {
                        name: 'reviews.detail',
                        topName: 'reviews.list',
                        content: 'Yorum Detay',
                        resource: 'menu.reviews.detail'
                    }
                }
            }
        ];
    }
})();